function isLocalStorageEnabled() {
    try {
        let mod = '__storage_test__';
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    } catch (e) {
        return false;
    }
}

export function captiveNetworkAssistantCheck() {
    // NOTE: https://stackoverflow.com/questions/19981008/javascript-detection-of-ios-captive-network-assistant-webpage
    let ua = navigator.userAgent.toLowerCase();
    if (
        (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) &&
        ua.indexOf('mozilla/') > -1 &&
        ua.indexOf('applewebkit/') > -1 &&
        ua.indexOf('mobile/') > -1 &&
        ua.indexOf('safari') === -1 &&
        !isLocalStorageEnabled()
    ) {
        // Yes, we are in a CNA popup
        return true;
    } else {
        return false;
    }
}
